<template>
  <div class="productTableCom">
    <v-data-table
      :headers="headers"
      :items="items"
      :item-key="itemKey"
      hide-default-header
      hide-default-footer
      :items-per-page="-1"
    >
      <template v-slot:[`header`]>
        <thead>
          <tr>
            <template v-for="(headerItem, headerIndex) in headers">
              <th
                :colspan="2"
                :rowspan="headerItem.children ? 1 : 2"
                :key="headerIndex"
                :class="{ half: headerItem.children }"
                :width="headerItem.width"
              >
                {{ $t(headerItem.text) }}
              </th>
            </template>
          </tr>
          <tr>
            <template v-for="(headerItem, headerIndex) in headers">
              <template v-if="headerItem.children">
                <th :key="headerIndex + '_1'" class="half">
                  {{ $t(headerItem.children[0].text) }}
                </th>
                <th :key="headerIndex + '_2'" class="half">
                  {{ $t(headerItem.children[1].text) }}
                </th>
              </template>
            </template>
          </tr>
        </thead>
      </template>

      <template v-slot:body="{ items }">
        <tbody>
          <tr v-if="!items.length">
            <td colspan="100%" class="text-center">
              {{ $t('sale.sale_not-product') }}
            </td>
          </tr>

          <tr v-for="(item, itemIndex) in items" :key="itemIndex">
            <template v-for="(headerItem, headerIndex) in headers">
              <td
                v-if="!headerItem.children"
                :key="headerIndex"
                :colspan="2"
                :rowspan="1"
                :class="{
                  'font-weight-bold': headerItem.value === 'productInfo',
                  'text-left':
                    headerItem.value === 'productNumber' ||
                    headerItem.value === 'productInfo'
                }"
              >
                {{
                  headerItem.value === 'productNumber' ||
                  headerItem.value === 'productInfo'
                    ? item[headerItem.value]
                    : getFormatedData(item[headerItem.value])
                }}
              </td>
              <template v-if="headerItem.children">
                <td :key="headerIndex + '_1'" class="font-weight-bold">
                  {{
                    getFormatedData(
                      item.storage.find(
                        (_item) => _item.id === headerItem.value
                      ).stock
                    )
                  }}
                </td>
                <td :key="headerIndex + '_2'">
                  {{
                    getFormatedData(
                      item.storage.find(
                        (_item) => _item.id === headerItem.value
                      ).moving
                    )
                  }}
                </td>
              </template>
            </template>
          </tr>
        </tbody>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import { commonUtil, currencyUtil } from '@/util'
import _cloneDeep from 'lodash/cloneDeep'

export default {
  name: 'ProductTable',

  components: {},
  props: {
    value: {
      type: Object,
      require: false,
      default: () => ({})
    },
    headers: {
      type: Array,
      default: () => []
    },
    items: [],
    itemKey: String,
    productKey: String
  },
  data: () => ({}),
  created() {},
  methods: {
    getFormatedData(value) {
      return commonUtil.formatPrice(value).toLocaleString()
    }
  }
}
</script>
<style lang="scss" scoped>
.productTableCom {
  ::v-deep .v-data-table th {
    background-color: rgba(151, 198, 234, 0.1);
    // border: solid 1px #d8d8d8;
    border-collapse: collapse;
    text-align: center !important;
    padding: 10px 0px !important;
    white-space: pre-wrap;
    background-color: #fafafb;

    border-bottom: 1px solid #d8d8d8;
    border-right: 1px solid #d8d8d8;
    word-break: break-word;
    &:last-of-type {
      border-right: 0 !important;
    }
  }
  ::v-deep .v-data-table table {
    table-layout: fixed;
  }
  ::v-deep .v-data-table thead {
    & > tr {
      height: 30px;
      th.half {
        height: 30px;
        padding: 0 !important;
      }
    }
  }
  ::v-deep .v-data-table td {
    background-color: #f6f6f6;
    border-collapse: collapse;
    color: #666666;
    border-bottom: 1px solid #d8d8d8;
    border-right: 1px solid #d8d8d8;
    border-spacing: 0;
    margin: -1px;
    white-space: pre-line;
    text-align: right;
    word-break: break-word;
    &:last-of-type {
      border-right: 0 !important;
    }
  }
  ::v-deep .v-data-table tr:nth-child(odd) td {
    background-color: #fff;
    border-collapse: collapse;

    border-bottom: 1px solid #d8d8d8;
    border-right: 1px solid #d8d8d8;
    border-spacing: 0;
    margin: -1px;
  }
  ::v-deep .v-data-table tr:hover td {
    background-color: #eee;
  }

  .tdStyleCenter {
    text-align: center !important;
    padding: 10px 0;
  }
  .tdStyleEnd {
    text-align: right !important;
  }
  .DisplayNone {
    display: none;
  }
}
</style>
